import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { AgenceEntity } from '../../../../entities/agence.entity';
import { PartenaireEntity } from '../../../../entities/partenaire.entity';
import { ORANGE } from '../../../../shared/colors';
import { createAgence } from '../network';

const FormShell = styled.div`
  color: var(--mt-text);

  .form-intro {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 14px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.1), transparent 42%),
      var(--mt-surface);
  }

  .form-intro span {
    color: var(--mt-warning);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-intro h3 {
    margin: 5px 0 0;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .ant-form-item-label label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 12px;
    text-transform: uppercase;
  }

  .ant-input {
    height: 42px;
    border-color: var(--mt-border);
    border-radius: 8px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .submit-button {
    min-width: 180px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, #ffb000);
    color: #07141c;
    font-family: Poppins-B;
  }
`;

export const AgenceForm = ({
  partenaire,
  setShowDrawer,
  getNewAgence,
}: {
  partenaire: PartenaireEntity;
  setShowDrawer: (b: boolean) => void;
  getNewAgence: (age: AgenceEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <FormShell>
      <div className='form-intro'>
        <span>Nouvelle agence</span>
        <h3>{partenaire?.nom}</h3>
      </div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        initialValues={{
          type: 'Banque',
        }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.partenaire = partenaire.url;

          await createAgence(data).then(({ data, statusCode }) => {
            if (statusCode?.toString()[0] === '2') {
              notification.success({
                message: 'Succès',
                description: "L'agence a été créé avec succès",
              });
              getNewAgence(data);
              setShowDrawer(false);
            } else {
              notification.info({
                message: 'Erreur',
                description: data.message,
              });
            }
            setIsLoading(false);
          });
        }}
      >
        <Form.Item
          label="Nom de l'agence"
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: "Entrez le nom de l'agence",
            },
          ]}
        >
          <Input placeholder="Entrez le nom de l'agence" />
        </Form.Item>
        <Form.Item
          label='Localisation'
          name='localisation'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la localisation',
            },
          ]}
        >
          <Input placeholder='Entrez la localisation' />
        </Form.Item>
        <Form.Item
          label='Code référent'
          name='code'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le code référent',
            },
          ]}
        >
          <Input placeholder='Entrez le code référent' />
        </Form.Item>
        <Form.Item>
          <Button
            htmlType='submit'
            className='submit-button'
            loading={isLoading}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </FormShell>
  );
};
